// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type ChevronUp20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const ChevronUp20: FC<ChevronUp20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="m16 11.38-1.007 1.24L10 8.532 5.007 12.62 4 11.381l6-4.914 6 4.914Z" />
        </svg>
    );
};

export default ChevronUp20;
